import { useCallback, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { executeApiAction } from '../../shared/utility/apiHelper';
import { getMyCheckoutRequestsAll } from '../services/checkout-requestService';

const usePortalCheckoutRequestsAll = () => {
  const dispatch = useDispatch();
  const [allCheckoutRequests, setAllCheckoutRequests] = useState([]);
  const [allCheckoutRequestsLoading, setAllCheckoutRequestsLoading] = useState(false);

  const loadAllCheckoutRequests = useCallback(() => {
    executeApiAction({
      setLoading: setAllCheckoutRequestsLoading,
      dispatch,
      action: () => getMyCheckoutRequestsAll(),
      onSuccess: (response) => setAllCheckoutRequests(response || []),
    });
  }, [dispatch]);

  useEffect(() => {
    loadAllCheckoutRequests();
  }, [loadAllCheckoutRequests]);

  return {
    allCheckoutRequests,
    allCheckoutRequestsLoading,
    refetchAllCheckoutRequests: loadAllCheckoutRequests,
  };
};

export default usePortalCheckoutRequestsAll;
